




























/** @format */

import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class PayInfo extends Vue {
  payMethods = ['现金', 'pos机', '银行转账', '其他'];
}
